import PortfolioItemContext from '@/components/ChallengePortfolio/NormalView/portfolio-item/PortfolioItemContext';
import useApi from '@/lib/api/useApi';
import { useContext } from 'react';

const useDeleteThumbnail = () => {
  const api = useApi();
  const {
    portfolioItem,
    setPortfolioItem,
    setPortfolioItemSummary,
    portfolioItemApiEndpoint,
  } = useContext(PortfolioItemContext);

  const deleteThumbnail = async (): Promise<void> => {
    await api.delete(
      `${portfolioItemApiEndpoint}/thumbnail/${portfolioItem.thumbnail!.id}`,
    );

    setPortfolioItem(portfolioItem => {
      portfolioItem.thumbnail = null;
    });

    setPortfolioItemSummary(portfolioItemSummary => {
      portfolioItemSummary.thumbnail = null;
    });
  };

  return deleteThumbnail;
};

export default useDeleteThumbnail;
